import { useLocation } from "react-router-dom";
import { Link } from "@/i18n/Link";
import { useLocale } from "@/i18n/LocaleContext";
import { switchLocalePath } from "@/i18n/locale";

/**
 * "Se Habla Español" (English pages) / "English" (Spanish pages).
 * Keeps the visitor on the equivalent page, preserving ?query and #hash.
 */
export function LanguageSwitch({
  compact = false,
  block = false,
  onNavigate,
}: {
  compact?: boolean;
  block?: boolean;
  onNavigate?: () => void;
}) {
  const { pathname, search, hash } = useLocation();
  const { locale } = useLocale();
  const target = locale === "es" ? "en" : "es";
  const href = switchLocalePath(pathname, search, hash, target);
  const label = locale === "es" ? "English" : "Se Habla Español";
  const shortLabel = locale === "es" ? "EN" : "ES";
  const aria =
    locale === "es"
      ? "View this page in English"
      : "Ver esta página en español";
  return (
    <Link
      to={href}
      locale={target}
      hrefLang={target}
      lang={target}
      aria-label={aria}
      title={label}
      onClick={onNavigate}
      className={`inline-flex items-center justify-center whitespace-nowrap rounded-md border border-primary bg-white font-bold text-primary transition-colors hover:bg-primary/5 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 ${
        compact ? "h-8 px-2.5 text-xs" : "h-9 px-3 text-sm"
      } ${block ? "w-full" : ""}`}
    >
      {compact ? shortLabel : label}
    </Link>
  );
}
